import { useTranslations } from 'next-intl'

import { Card } from '@/entities/auth'
import { CertificationButton } from '@/features/verify-identity'
import { Slot } from '@/shared/lib'

type Props = {
  onCertificationSuccess: (certNum: string) => void
}

export const Certification = ({ onCertificationSuccess }: Props) => {
  const t = useTranslations('find_password')

  return (
    <Card>
      <Slot name="title">{t('title')}</Slot>
      <Slot name="description">{t('description')}</Slot>
      <Slot name="children">
        <CertificationButton onSuccess={onCertificationSuccess}>
          {t('button.verify_identity')}
        </CertificationButton>
      </Slot>
    </Card>
  )
}
